export default __webpack_public_path__ + "static/media/ANEXO-III-Declaracao-de-nao-retencao-IR-RPV.811b2f59.docx";